import { CtaButton, EmailInput } from '@opendoor/bricks';
import * as React from 'react';
import { captureInboundCampaignEmail } from '../api';
import CtaExplain from '../components/common/CtaExplain';

type EmailCallToActionProps = {
  campaign: string;
  inputPlaceholder: string;
  submitErrorText: string;
  submitText: string;
  successText: string;
};

type EmailCallToActionState = {
  email: string;
  isSubmitError: boolean;
  isSubmitted: boolean;
  isSubmitting: boolean;
  isValidEmail: boolean;
};
export class EmailCallToAction extends React.Component<
  EmailCallToActionProps,
  EmailCallToActionState
> {
  public state = {
    email: '',
    isSubmitError: false,
    isSubmitted: false,
    isSubmitting: false,
    isValidEmail: false,
  };
  public render() {
    return (
      <div>
        <div>
          <EmailInput
            content={this.state.email}
            designStyle={'rounded'}
            unboundedWidth={true}
            alignText={'center'}
            disabled={this.state.isSubmitting}
            placeholder={this.props.inputPlaceholder}
            name={'call-to-action-email'}
            onChange={this.onEmailChange}
            autoComplete={'email'}
          />
        </div>
        {!this.state.isSubmitted ? (
          <CtaButton
            actionText={this.props.submitText}
            onClick={this.onEmailSubmit}
            designStyle={'rounded'}
            marginType={'medium'}
            loading={this.state.isSubmitting}
            loadingText={'Subscribing...'}
          />
        ) : (
          <CtaExplain
            actionText={this.props.successText}
            designStyle={'rounded'}
            marginType={'medium'}
          />
        )}
        {this.state.isSubmitError && <p className="error-prompt">{this.props.submitErrorText}</p>}
      </div>
    );
  }
  private onEmailChange = (name: string, newValue: string, validFormat: boolean) => {
    this.setState({
      email: newValue,
      isSubmitError: false,
      isSubmitted: false,
      isValidEmail: validFormat,
    });
  };
  private onEmailSubmit = async () => {
    this.setState({ isSubmitting: true, isSubmitError: false });
    try {
      await captureInboundCampaignEmail(this.state.email, this.props.campaign);
      this.setState({ isSubmitting: false, isSubmitError: false, isSubmitted: true });
    } catch (e) {
      this.setState({ isSubmitting: false, isSubmitError: true });
    }
  };
}
